import React from 'react';
import { useSelector } from 'react-redux';
import pluralize from 'pluralize';
import { Spinner } from 'react-bootstrap-5';

import { formatWithCommas } from 'helpers/formatters/number_formats';
import { selectLoading, selectShowTableView } from 'bundles/connect/components/store/selectors/ui';
import { selectTotal } from 'bundles/connect/components/store/selectors/results';

export default function PropertyCountOverlay() {
  const loading = useSelector(selectLoading);
  const showTableView = useSelector(selectShowTableView);
  const total = useSelector(selectTotal);

  if (showTableView) {
    return null;
  }

  const formattedTotal = total?.toLocaleString();

  return (
    <div
      className={`d-flex flex-column p-2 m-4 rounded shadow position-absolute`}
      style={{ backgroundColor: '#fff' }}
    >
      <span className="fw-bold">
        {loading || !formattedTotal ? (
          <div className="d-flex align-items-center">
            <Spinner animation="border" size="sm" variant="secondary" />
            <span className="ms-3">Loading...</span>
          </div>
        ) :
          (<>{formatWithCommas(formattedTotal)} {pluralize('Property', total)}</>)
        }
      </span>
    </div>
  );

}
